import { withCompInfo } from '@wix/editor-elements-integrations'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { ThemeFontMap } from '@wix/thunderbolt-becky-types'
import { CompInfo } from '@wix/thunderbolt-components-native'
import { CheckboxGroupDefinition } from '../CheckboxGroup/CheckboxGroup'
import { CheckboxCSSVars, CheckboxDefinition } from './Checkbox'
import { getHeightInPixels } from '../../utils/singleLayoutUtils'

export const getCheckboxCss = ({
	compProps,
	compData,
	compLayout,
	compSingleLayout,
	hasResponsiveLayout,
	structure,
	styleProperties,
	siteFonts,
	isMobileView,
	isOneDocMigrated,
}: Pick<
	CompInfo<CheckboxDefinition | CheckboxGroupDefinition>,
	| 'compData'
	| 'compProps'
	| 'compLayout'
	| 'compSingleLayout'
	| 'hasResponsiveLayout'
	| 'structure'
	| 'styleProperties'
	| 'isMobileView'
	| 'isOneDocMigrated'
> & { siteFonts: ThemeFontMap }): CheckboxCSSVars => {
	const { alignment, buttonSize, spacing, inputMobileFontSize } = compProps
	const isRightAlignment = alignment === 'right'
	const isGroupOrLabel = structure.componentType === 'CheckboxGroup' || compData.label
	const getClassicButtonSize = () => {
		return isOneDocMigrated ? getHeightInPixels(compSingleLayout) : compLayout.height
	}
	const size = hasResponsiveLayout || isGroupOrLabel ? buttonSize : getClassicButtonSize()

	const compInfo = { compLayout, compProps, styleProperties, siteFonts, isMobileView }
	return {
		'--fnt': getScaledFont(compInfo, 'fnt', isOneDocMigrated, inputMobileFontSize),
		'--checkboxSize': `${size}px`,
		'--dir': isRightAlignment ? ('rtl' as const) : ('ltr' as const),
		'--flexDirection': isRightAlignment ? ('row-reverse' as const) : ('reverse' as const),
		'--checkmarkMargin': isRightAlignment ? `auto -${size}px auto auto` : `auto auto auto -${size}px`,
		...(isGroupOrLabel && {
			'--labelMargin': isRightAlignment ? `0 ${spacing + 1}px 0 0` : `0 0 0 ${spacing + 1}px`,
		}),
		...(!hasResponsiveLayout &&
			!isOneDocMigrated && {
				height: 'auto' as const,
			}),
	}
}

export const css = withCompInfo<CheckboxCSSVars, CheckboxDefinition>()(
	[
		'compProps',
		'compData',
		'compLayout',
		'compSingleLayout',
		'hasResponsiveLayout',
		'structure',
		'styleProperties',
		'siteFonts',
		'isMobileView',
		'isOneDocMigrated',
	],
	getCheckboxCss
)
